import ColorPicker from "@components/color-picker";
import Popover from "@components/ui/popover";
import { cn } from "@lib/cn";
import { IconColorPicker } from "@tabler/icons-react";
import { useState } from "react";

interface Props {
  value: string;
  onChange: (value: string) => void;
  invalid?: boolean;
}

export const ColorControl = ({ value, onChange, invalid = false }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      placement="bottom-start"
      offset={2}
    >
      <Popover.Trigger asChild>
        <button
          type="button"
          className={cn(
            "tw-flex tw-h-9 tw-w-full tw-items-center tw-gap-2 tw-rounded-lg tw-border-none tw-bg-white tw-px-2 tw-text-sm tw-font-normal tw-text-blue-500 tw-outline-none",
            open && "tw-bg-[#f3f2f5]",
            value && "tw-text-blue",
            invalid && "tw-bg-[#FAF1F2] tw-text-[#D43548]",
          )}
        >
          {value ? (
            <span
              className="tw-size-4 tw-rounded tw-border tw-border-solid tw-border-blue/10"
              style={{ backgroundColor: value }}
            />
          ) : (
            <IconColorPicker className="tw-size-4 !tw-fill-none" />
          )}
          <span>{value || "Select color"}</span>
        </button>
      </Popover.Trigger>
      <Popover.Content className="tw-z-[1000000] tw-w-[280px] tw-rounded-xl tw-border tw-border-solid tw-border-blue/5 tw-bg-white tw-shadow-sm">
        <ColorPicker
          key={value}
          current={value || "#610cff"}
          disableGradient
          onColorChange={onChange}
        />
      </Popover.Content>
    </Popover>
  );
};
